import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1716">
      <Hero data-id="element-1717" />
      <WhyUs data-id="element-1718" />
      <Services data-id="element-1719" />
      <HowItWorks data-id="element-1720" />
      <FAQ data-id="element-1721" />
      <Reviews data-id="element-1722" />
      <CtaBanner data-id="element-1723" />
    </main>;
}